import { render, staticRenderFns } from "./ClientError.vue?vue&type=template&id=eedf3f24&scoped=true"
import script from "./ClientError.vue?vue&type=script&setup=true&lang=ts"
export * from "./ClientError.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ClientError.vue?vue&type=style&index=0&id=eedf3f24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eedf3f24",
  null
  
)

export default component.exports